import React, { useCallback, useMemo } from 'react';
import SvgSearch from '@img/icons/search.svg';
import { Divide as Hamburger } from 'hamburger-react';
import S from './MobileHeader.styles';
const MobileHeader = ({ isActive, isSearchActive, reduced = false, onNavigationToggle, onSearchToggle, }) => {
    const onSearchClick = useCallback((event) => {
        event.preventDefault();
        onSearchToggle();
    }, [onSearchToggle]);
    const searchLabel = useMemo(() => (isSearchActive ? 'Close Search' : 'Open Search'), [isSearchActive]);
    const onHamburgerClick = useCallback((event) => {
        event.preventDefault();
        onNavigationToggle();
    }, [onNavigationToggle]);
    const hamburgerLabel = useMemo(() => (isActive ? 'Close Menu' : 'Open Menu'), [isActive]);
    const hamburgerColour = useMemo(() => (isActive ? '#000' : '#fff'), [isActive]);
    return (React.createElement(S.Container, null,
        !reduced && (React.createElement(S.Button, { onClick: onSearchClick, "aria-label": searchLabel, "aria-expanded": isSearchActive ? 'true' : 'false', title: searchLabel },
            React.createElement(SvgSearch, { "aria-hidden": "true" }))),
        !reduced && (React.createElement(S.HamburgerButton, { onClick: onHamburgerClick, "aria-label": hamburgerLabel, title: hamburgerLabel, "data-active": isActive },
            React.createElement(Hamburger, { color: hamburgerColour, size: 24, toggled: false, label: hamburgerLabel, "aria-hidden": "true" })))));
};
export default MobileHeader;
